export const getProductById = (payload: { id: number }) => ({
    type: "@saga/GET_PRODUCT_BY_ID",
    payload
});